var SWE_1_0_1_Module_Factory = function () {
  var SWE_1_0_1 = {
    n: 'SWE_1_0_1',
    dens: 'http:\/\/www.opengis.net\/swe\/1.0.1',
    dans: 'http:\/\/www.w3.org\/1999\/xlink',
    deps: ['XLink_1_0', 'GML_3_1_1'],
    tis: [{
        ln: 'DataRecordType',
        bti: '.AbstractDataRecordType',
        ps: [{
            n: 'field',
            mno: 0,
            col: true,
            ti: '.DataComponentPropertyType'
          }]
      }, {
        ln: 'PositionType',
        bti: '.AbstractVectorType',
        ps: [{
            n: 'time',
            ti: '.TimePropertyType'
          }, {
            n: 'location',
            ti: '.VectorPropertyType'
          }, {
            n: 'orientation',
            ti: '.VectorOrSquareMatrixPropertyType'
          }, {
            n: 'velocity',
            ti: '.VectorPropertyType'
          }, {
            n: 'angularVelocity',
            ti: '.VectorOrSquareMatrixPropertyType'
          }, {
            n: 'acceleration',
            ti: '.VectorPropertyType'
          }, {
            n: 'angularAcceleration',
            ti: '.VectorOrSquareMatrixPropertyType'
          }, {
            n: 'state',
            ti: '.VectorOrSquareMatrixPropertyType'
          }]
      }, {
        ln: 'Boolean',
        tn: null,
        bti: '.AbstractDataComponentType',
        ps: [{
            n: 'quality',
            ti: '.QualityPropertyType'
          }, {
            n: 'value',
            ti: 'Boolean'
          }, {
            n: 'referenceFrame',
            an: {
              lp: 'referenceFrame'
            },
            t: 'a'
          }, {
            n: 'axisID',
            ti: 'Token',
            an: {
              lp: 'axisID'
            },
            t: 'a'
          }]
      }, {
        ln: 'AllowedTokensPropertyType',
        ps: [{
            n: 'allowedTokens',
            rq: true,
            en: 'AllowedTokens',
            ti: '.AllowedTokens'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'TimeGeometricPrimitivePropertyType',
        ps: [{
            n: 'timeGeometricPrimitive',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: '_TimeGeometricPrimitive',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_1_1.AbstractTimeGeometricPrimitiveType',
            t: 'er'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'PhenomenonType',
        bti: 'GML_3_1_1.DefinitionType'
      }, {
        ln: 'CurveType',
        bti: '.AbstractDataArrayType',
        ps: [{
            n: 'elementType',
            rq: true,
            ti: '.SimpleDataRecordPropertyType'
          }, {
            n: 'encoding',
            rq: true,
            ti: '.BlockEncodingPropertyType'
          }, {
            n: 'values',
            ti: '.DataValuePropertyType'
          }]
      }, {
        ln: 'BinaryBlock.Member.Component',
        tn: null,
        ps: [{
            n: 'ref',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'ref'
            },
            t: 'a'
          }, {
            n: 'dataType',
            an: {
              lp: 'dataType'
            },
            t: 'a'
          }, {
            n: 'significantBits',
            ti: 'PositiveInteger',
            an: {
              lp: 'significantBits'
            },
            t: 'a'
          }, {
            n: 'bitLength',
            ti: 'PositiveInteger',
            an: {
              lp: 'bitLength'
            },
            t: 'a'
          }, {
            n: 'paddingBitsBefore',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'paddingBits-before'
            },
            t: 'a'
          }, {
            n: 'paddingBitsAfter',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'paddingBits-after'
            },
            t: 'a'
          }, {
            n: 'encryption',
            an: {
              lp: 'encryption'
            },
            t: 'a'
          }]
      }, {
        ln: 'EnvelopeType',
        bti: '.AbstractVectorType',
        ps: [{
            n: 'time',
            ti: '.TimeRangePropertyType'
          }, {
            n: 'lowerCorner',
            rq: true,
            ti: '.VectorPropertyType'
          }, {
            n: 'upperCorner',
            rq: true,
            ti: '.VectorPropertyType'
          }]
      }, {
        ln: 'Time',
        tn: null,
        bti: '.AbstractDataComponentType',
        ps: [{
            n: 'uom',
            ti: '.UomPropertyType'
          }, {
            n: 'constraint',
            ti: '.AllowedTimesPropertyType'
          }, {
            n: 'quality',
            ti: '.QualityPropertyType'
          }, {
            n: 'value',
            ti: {
              t: 'l'
            }
          }, {
            n: 'referenceTime',
            an: {
              lp: 'referenceTime'
            },
            t: 'a'
          }, {
            n: 'referenceFrame',
            an: {
              lp: 'referenceFrame'
            },
            t: 'a'
          }, {
            n: 'localFrame',
            an: {
              lp: 'localFrame'
            },
            t: 'a'
          }]
      }, {
        ln: 'IntervalPropertyType',
        ps: [{
            n: 'interval',
            rq: true,
            en: 'Interval',
            ti: '.IntervalType'
          }]
      }, {
        ln: 'ConditionalValueType',
        bti: '.AbstractConditionalType',
        ps: [{
            n: 'data',
            rq: true,
            ti: '.ConditionalValueType.Data'
          }]
      }, {
        ln: 'MultiplexedStreamFormatPropertyType',
        ps: [{
            n: 'multiplexedStreamFormat',
            en: 'MultiplexedStreamFormat',
            ti: '.MultiplexedStreamFormatType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'AnyScalarPropertyType',
        ps: [{
            n: 'count',
            rq: true,
            en: 'Count',
            ti: '.Count'
          }, {
            n: 'quantity',
            rq: true,
            en: 'Quantity',
            ti: '.Quantity'
          }, {
            n: 'time',
            rq: true,
            en: 'Time',
            ti: '.Time'
          }, {
            n: '_boolean',
            rq: true,
            en: 'Boolean',
            ti: '.Boolean'
          }, {
            n: 'category',
            rq: true,
            en: 'Category',
            ti: '.Category'
          }, {
            n: 'text',
            rq: true,
            en: 'Text',
            ti: '.Text'
          }, {
            n: 'name',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'TimeAggregatePropertyType',
        ps: [{
            n: 'timeAggregate',
            rq: true,
            en: 'TimeAggregate',
            ti: '.TimeAggregateType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'SimpleDataRecordPropertyType',
        ps: [{
            n: 'simpleDataRecord',
            rq: true,
            en: 'SimpleDataRecord',
            ti: '.SimpleDataRecordType'
          }]
      }, {
        ln: 'TimeRangePropertyType',
        ps: [{
            n: 'timeRange',
            rq: true,
            en: 'TimeRange',
            ti: '.TimeRange'
          }]
      }, {
        ln: 'RecordType',
        ps: [{
            n: 'field',
            rq: true,
            col: true,
            ti: '.ItemPropertyType'
          }, {
            n: 'rs',
            an: {
              lp: 'RS'
            },
            t: 'a'
          }, {
            n: 'fieldCount',
            ti: 'PositiveInteger',
            an: {
              lp: 'fieldCount'
            },
            t: 'a'
          }]
      }, {
        ln: 'CategoryPropertyType',
        ps: [{
            n: 'category',
            rq: true,
            en: 'Category',
            ti: '.Category'
          }]
      }, {
        ln: 'AbstractMatrixType',
        bti: '.AbstractDataArrayType',
        ps: [{
            n: 'referenceFrame',
            an: {
              lp: 'referenceFrame'
            },
            t: 'a'
          }, {
            n: 'localFrame',
            an: {
              lp: 'localFrame'
            },
            t: 'a'
          }]
      }, {
        ln: 'XMLDataPropertyType',
        ps: [{
            n: 'item',
            rq: true,
            en: 'Item',
            ti: 'AnyType'
          }, {
            n: 'record',
            rq: true,
            en: 'Record',
            ti: '.RecordType'
          }, {
            n: 'array',
            rq: true,
            en: 'Array',
            ti: '.ArrayType'
          }]
      }, {
        ln: 'TimeGridEnvelopePropertyType',
        ps: [{
            n: 'timeGridEnvelope',
            rq: true,
            en: 'TimeGridEnvelope',
            ti: '.TimeGridEnvelopePropertyType.TimeGridEnvelope'
          }]
      }, {
        ln: 'VectorType',
        bti: '.AbstractVectorType',
        ps: [{
            n: 'coordinate',
            rq: true,
            col: true,
            ti: '.VectorType.Coordinate'
          }]
      }, {
        ln: 'VectorType.Coordinate',
        tn: null,
        ps: [{
            n: 'count',
            rq: true,
            en: 'Count',
            ti: '.Count'
          }, {
            n: 'quantity',
            rq: true,
            en: 'Quantity',
            ti: '.Quantity'
          }, {
            n: 'time',
            rq: true,
            en: 'Time',
            ti: '.Time'
          }, {
            n: 'name',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'name'
            },
            t: 'a'
          }]
      }, {
        ln: 'Category',
        tn: null,
        bti: '.AbstractDataComponentType',
        ps: [{
            n: 'codeSpace',
            ti: '.CodeSpacePropertyType'
          }, {
            n: 'constraint',
            ti: '.AllowedTokensPropertyType'
          }, {
            n: 'quality',
            ti: '.QualityPropertyType'
          }, {
            n: 'value',
            ti: 'Token'
          }, {
            n: 'referenceFrame',
            an: {
              lp: 'referenceFrame'
            },
            t: 'a'
          }, {
            n: 'axisID',
            ti: 'Token',
            an: {
              lp: 'axisID'
            },
            t: 'a'
          }]
      }, {
        ln: 'StandardFormat',
        tn: null,
        bti: '.AbstractEncodingType',
        ps: [{
            n: 'mimeType',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'mimeType'
            },
            t: 'a'
          }]
      }, {
        ln: 'TimeAggregateType',
        bti: 'GML_3_1_1.AbstractTimeObjectType',
        ps: [{
            n: 'member',
            rq: true,
            col: true,
            ti: '.TimeObjectPropertyType'
          }]
      }, {
        ln: 'CountPropertyType',
        ps: [{
            n: 'count',
            rq: true,
            en: 'Count',
            ti: '.Count'
          }]
      }, {
        ln: 'DataArrayType',
        bti: '.AbstractDataArrayType',
        ps: [{
            n: 'elementType',
            rq: true,
            ti: '.DataComponentPropertyType'
          }, {
            n: 'encoding',
            rq: true,
            ti: '.BlockEncodingPropertyType'
          }, {
            n: 'values',
            ti: '.DataValuePropertyType'
          }]
      }, {
        ln: 'AbstractDataComponentType',
        bti: 'GML_3_1_1.AbstractGMLType',
        ps: [{
            n: 'fixed',
            ti: 'Boolean',
            an: {
              lp: 'fixed'
            },
            t: 'a'
          }, {
            n: 'definition',
            an: {
              lp: 'definition'
            },
            t: 'a'
          }]
      }, {
        ln: 'CountRange',
        tn: null,
        bti: '.AbstractDataComponentType',
        ps: [{
            n: 'constraint',
            ti: '.AllowedValuesPropertyType'
          }, {
            n: 'quality',
            mno: 0,
            col: true,
            ti: '.QualityPropertyType'
          }, {
            n: 'value',
            ti: {
              t: 'l',
              bti: 'Integer'
            }
          }, {
            n: 'referenceFrame',
            an: {
              lp: 'referenceFrame'
            },
            t: 'a'
          }, {
            n: 'axisID',
            ti: 'Token',
            an: {
              lp: 'axisID'
            },
            t: 'a'
          }]
      }, {
        ln: 'AbstractConditionalType',
        bti: '.AbstractDataRecordType',
        ps: [{
            n: 'condition',
            rq: true,
            col: true,
            ti: '.AbstractConditionalType.Condition'
          }]
      }, {
        ln: 'TimeRange',
        tn: null,
        bti: '.AbstractDataComponentType',
        ps: [{
            n: 'uom',
            ti: '.UomPropertyType'
          }, {
            n: 'constraint',
            ti: '.AllowedTimesPropertyType'
          }, {
            n: 'quality',
            ti: '.QualityPropertyType'
          }, {
            n: 'value',
            ti: {
              t: 'l'
            }
          }, {
            n: 'referenceTime',
            an: {
              lp: 'referenceTime'
            },
            t: 'a'
          }, {
            n: 'referenceFrame',
            an: {
              lp: 'referenceFrame'
            },
            t: 'a'
          }, {
            n: 'localFrame',
            an: {
              lp: 'localFrame'
            },
            t: 'a'
          }]
      }, {
        ln: 'ConditionalDataType',
        bti: '.AbstractDataRecordType',
        ps: [{
            n: '_case',
            rq: true,
            col: true,
            en: 'case',
            ti: '.ConditionalDataType.Case'
          }]
      }, {
        ln: 'QuantityRange',
        tn: null,
        bti: '.AbstractDataComponentType',
        ps: [{
            n: 'uom',
            ti: '.UomPropertyType'
          }, {
            n: 'constraint',
            ti: '.AllowedValuesPropertyType'
          }, {
            n: 'quality',
            mno: 0,
            col: true,
            ti: '.QualityPropertyType'
          }, {
            n: 'value',
            ti: {
              t: 'l',
              bti: 'Double'
            }
          }, {
            n: 'referenceFrame',
            an: {
              lp: 'referenceFrame'
            },
            t: 'a'
          }, {
            n: 'axisID',
            ti: 'Token',
            an: {
              lp: 'axisID'
            },
            t: 'a'
          }]
      }, {
        ln: 'TimeGridEnvelopePropertyType.TimeGridEnvelope',
        tn: null,
        ps: [{
            n: 'low',
            rq: true,
            ti: 'Integer'
          }, {
            n: 'high',
            rq: true,
            ti: 'Integer'
          }]
      }, {
        ln: 'DataArrayPropertyType',
        ps: [{
            n: 'dataArray',
            rq: true,
            en: 'DataArray',
            ti: '.DataArrayType'
          }]
      }, {
        ln: 'DataStreamDefinitionType',
        ps: [{
            n: 'streamComponent',
            rq: true,
            col: true,
            ti: '.DataBlockDefinitionPropertyType'
          }, {
            n: 'streamEncoding',
            rq: true,
            ti: '.MultiplexedStreamFormatPropertyType'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }]
      }, {
        ln: 'BooleanPropertyType',
        ps: [{
            n: '_boolean',
            rq: true,
            en: 'Boolean',
            ti: '.Boolean'
          }]
      }, {
        ln: 'ConditionalValueType.Data',
        tn: null,
        ps: [{
            n: 'count',
            rq: true,
            en: 'Count',
            ti: '.Count'
          }, {
            n: 'quantity',
            rq: true,
            en: 'Quantity',
            ti: '.Quantity'
          }, {
            n: 'time',
            rq: true,
            en: 'Time',
            ti: '.Time'
          }, {
            n: '_boolean',
            rq: true,
            en: 'Boolean',
            ti: '.Boolean'
          }, {
            n: 'category',
            rq: true,
            en: 'Category',
            ti: '.Category'
          }, {
            n: 'text',
            rq: true,
            en: 'Text',
            ti: '.Text'
          }, {
            n: 'quantityRange',
            rq: true,
            en: 'QuantityRange',
            ti: '.QuantityRange'
          }, {
            n: 'countRange',
            rq: true,
            en: 'CountRange',
            ti: '.CountRange'
          }, {
            n: 'timeRange',
            rq: true,
            en: 'TimeRange',
            ti: '.TimeRange'
          }, {
            n: 'abstractDataRecord',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractDataRecord',
            ti: '.AbstractDataRecordType',
            t: 'er'
          }, {
            n: 'abstractDataArray',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractDataArray',
            ti: '.AbstractDataArrayType',
            t: 'er'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'AbstractVectorType',
        bti: '.AbstractDataRecordType',
        ps: [{
            n: 'referenceFrame',
            an: {
              lp: 'referenceFrame'
            },
            t: 'a'
          }, {
            n: 'localFrame',
            an: {
              lp: 'localFrame'
            },
            t: 'a'
          }]
      }, {
        ln: 'ScopedNameType',
        ps: [{
            n: 'value',
            t: 'v'
          }, {
            n: 'codeSpace',
            rq: true,
            an: {
              lp: 'codeSpace'
            },
            t: 'a'
          }]
      }, {
        ln: 'AllowedTokens',
        tn: null,
        ps: [{
            n: 'valueList',
            rq: true,
            col: true,
            mx: false,
            dom: false,
            ti: {
              t: 'l',
              bti: 'Token'
            },
            t: 'er'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }]
      }, {
        ln: 'AllowedTimes',
        tn: null,
        ps: [{
            n: 'min',
            rq: true,
            ti: {
              t: 'l'
            }
          }, {
            n: 'max',
            rq: true,
            ti: {
              t: 'l'
            }
          }, {
            n: 'intervalOrValueList',
            rq: true,
            col: true,
            mx: false,
            dom: false,
            etis: [{
                en: 'valueList',
                ti: {
                  t: 'l'
                }
              }, {
                en: 'interval',
                ti: {
                  t: 'l'
                }
              }],
            t: 'ers'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }]
      }, {
        ln: 'TimeGeometricComplexType',
        bti: 'GML_3_1_1.AbstractTimeComplexType',
        ps: [{
            n: 'primitive',
            rq: true,
            col: true,
            ti: '.TimeGeometricPrimitivePropertyType'
          }]
      }, {
        ln: 'NormalizedCurveType',
        bti: '.AbstractDataRecordType',
        ps: [{
            n: 'inputGain',
            ti: '.QuantityPropertyType'
          }, {
            n: 'inputBias',
            ti: '.QuantityPropertyType'
          }, {
            n: 'outputGain',
            ti: '.QuantityPropertyType'
          }, {
            n: 'outputBias',
            ti: '.QuantityPropertyType'
          }, {
            n: 'interpolationMethod',
            ti: '.CategoryPropertyType'
          }, {
            n: 'extrapolationMethod',
            ti: '.CategoryPropertyType'
          }, {
            n: 'function',
            rq: true,
            ti: '.CurvePropertyType'
          }]
      }, {
        ln: 'TimeGridPropertyType',
        ps: [{
            n: 'timeInstantGrid',
            rq: true,
            en: 'TimeInstantGrid',
            ti: '.TimeInstantGridType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'TimeInstantGridPropertyType',
        ps: [{
            n: 'timeInstantGrid',
            rq: true,
            en: 'TimeInstantGrid',
            ti: '.TimeInstantGridType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CodeSpacePropertyType',
        ps: [{
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'GeoLocationArea',
        tn: null,
        bti: '.AbstractVectorType',
        ps: [{
            n: 'member',
            rq: true,
            col: true,
            ti: '.EnvelopePropertyType'
          }, {
            n: 'geoLocationAreaName',
            ti: 'Token',
            an: {
              lp: 'name'
            },
            t: 'a'
          }]
      }, {
        ln: 'QuantityPropertyType',
        ps: [{
            n: 'quantity',
            rq: true,
            en: 'Quantity',
            ti: '.Quantity'
          }]
      }, {
        ln: 'PhenomenonPropertyType',
        ps: [{
            n: 'phenomenon',
            rq: true,
            mx: false,
            dom: false,
            en: 'Phenomenon',
            ti: '.PhenomenonType',
            t: 'er'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'DataComponentPropertyType',
        ps: [{
            n: 'count',
            rq: true,
            en: 'Count',
            ti: '.Count'
          }, {
            n: 'quantity',
            rq: true,
            en: 'Quantity',
            ti: '.Quantity'
          }, {
            n: 'time',
            rq: true,
            en: 'Time',
            ti: '.Time'
          }, {
            n: '_boolean',
            rq: true,
            en: 'Boolean',
            ti: '.Boolean'
          }, {
            n: 'category',
            rq: true,
            en: 'Category',
            ti: '.Category'
          }, {
            n: 'text',
            rq: true,
            en: 'Text',
            ti: '.Text'
          }, {
            n: 'quantityRange',
            rq: true,
            en: 'QuantityRange',
            ti: '.QuantityRange'
          }, {
            n: 'countRange',
            rq: true,
            en: 'CountRange',
            ti: '.CountRange'
          }, {
            n: 'timeRange',
            rq: true,
            en: 'TimeRange',
            ti: '.TimeRange'
          }, {
            n: 'abstractDataRecord',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractDataRecord',
            ti: '.AbstractDataRecordType',
            t: 'er'
          }, {
            n: 'abstractDataArray',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractDataArray',
            ti: '.AbstractDataArrayType',
            t: 'er'
          }, {
            n: 'name',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ConstrainedPhenomenonType',
        bti: '.PhenomenonType',
        ps: [{
            n: 'base',
            rq: true,
            ti: '.PhenomenonPropertyType'
          }, {
            n: 'otherConstraint',
            mno: 0,
            col: true
          }, {
            n: 'singleConstraint',
            mno: 0,
            col: true,
            ti: '.AnyDataPropertyType'
          }]
      }, {
        ln: 'BinaryBlock',
        tn: null,
        bti: '.AbstractEncodingType',
        ps: [{
            n: 'member',
            rq: true,
            col: true,
            ti: '.BinaryBlock.Member'
          }, {
            n: 'byteLength',
            ti: 'PositiveInteger',
            an: {
              lp: 'byteLength'
            },
            t: 'a'
          }, {
            n: 'byteEncoding',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'byteEncoding'
            },
            t: 'a'
          }, {
            n: 'byteOrder',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'byteOrder'
            },
            t: 'a'
          }]
      }, {
        ln: 'VectorOrSquareMatrixPropertyType',
        ps: [{
            n: 'vector',
            rq: true,
            en: 'Vector',
            ti: '.VectorType'
          }, {
            n: 'squareMatrix',
            rq: true,
            en: 'SquareMatrix',
            ti: '.SquareMatrixType'
          }]
      }, {
        ln: 'EnvelopePropertyType',
        ps: [{
            n: 'envelope',
            rq: true,
            en: 'Envelope',
            ti: '.EnvelopeType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'RecordPropertyType',
        ps: [{
            n: 'record',
            rq: true,
            en: 'Record',
            ti: '.RecordType'
          }]
      }, {
        ln: 'SquareMatrixType',
        bti: '.AbstractMatrixType',
        ps: [{
            n: 'elementType',
            rq: true,
            ti: '.QuantityPropertyType'
          }, {
            n: 'encoding',
            rq: true,
            ti: '.BlockEncodingPropertyType'
          }, {
            n: 'values',
            ti: '.DataValuePropertyType'
          }]
      }, {
        ln: 'AllowedValuesPropertyType',
        ps: [{
            n: 'allowedValues',
            rq: true,
            en: 'AllowedValues',
            ti: '.AllowedValues'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'TimeObjectPropertyType',
        ps: [{
            n: 'timeObject',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: '_TimeObject',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_1_1.AbstractTimeObjectType',
            t: 'er'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'TimeInstantGridType',
        bti: '.TimeGridType'
      }, {
        ln: 'QualityPropertyType',
        ps: [{
            n: 'quantity',
            rq: true,
            en: 'Quantity',
            ti: '.Quantity'
          }, {
            n: 'quantityRange',
            rq: true,
            en: 'QuantityRange',
            ti: '.QuantityRange'
          }, {
            n: 'category',
            rq: true,
            en: 'Category',
            ti: '.Category'
          }, {
            n: 'text',
            rq: true,
            en: 'Text',
            ti: '.Text'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'UomPropertyType',
        ps: [{
            n: 'unitDefinition',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'UnitDefinition',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_1_1.UnitDefinitionType',
            t: 'er'
          }, {
            n: 'code',
            an: {
              lp: 'code'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'BinaryBlock.Member',
        tn: null,
        ps: [{
            n: 'component',
            rq: true,
            en: 'Component',
            ti: '.BinaryBlock.Member.Component'
          }, {
            n: 'block',
            rq: true,
            en: 'Block',
            ti: '.BinaryBlock.Member.Block'
          }]
      }, {
        ln: 'ConditionalDataType.Case',
        tn: null,
        ps: [{
            n: 'conditionalValue',
            en: 'ConditionalValue',
            ti: '.ConditionalValueType'
          }, {
            n: 'name',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'DataValuePropertyType',
        ps: [{
            n: 'otherAttributes',
            t: 'aa'
          }, {
            n: 'content',
            col: true,
            t: 'ae'
          }, {
            n: 'recordCount',
            ti: 'PositiveInteger',
            an: {
              lp: 'recordCount'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'BlockEncodingPropertyType',
        ps: [{
            n: 'standardFormat',
            rq: true,
            en: 'StandardFormat',
            ti: '.StandardFormat'
          }, {
            n: 'binaryBlock',
            rq: true,
            en: 'BinaryBlock',
            ti: '.BinaryBlock'
          }, {
            n: 'textBlock',
            rq: true,
            en: 'TextBlock',
            ti: '.TextBlock'
          }, {
            n: 'xmlBlock',
            rq: true,
            en: 'XMLBlock',
            ti: '.XMLBlockType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'IntervalType',
        ps: [{
            n: 'lowerBound',
            rq: true,
            ti: 'AnyType'
          }, {
            n: 'upperBound',
            rq: true,
            ti: 'AnyType'
          }]
      }, {
        ln: 'ArrayPropertyType',
        ps: [{
            n: 'array',
            rq: true,
            en: 'Array',
            ti: '.ArrayType'
          }]
      }, {
        ln: 'DataBlockDefinitionType',
        ps: [{
            n: 'components',
            rq: true,
            ti: '.DataComponentPropertyType'
          }, {
            n: 'encoding',
            rq: true,
            ti: '.BlockEncodingPropertyType'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }]
      }, {
        ln: 'BinaryBlock.Member.Block',
        tn: null,
        ps: [{
            n: 'ref',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'ref'
            },
            t: 'a'
          }, {
            n: 'byteLength',
            ti: 'PositiveInteger',
            an: {
              lp: 'byteLength'
            },
            t: 'a'
          }, {
            n: 'paddingBytesBefore',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'paddingBytes-before'
            },
            t: 'a'
          }, {
            n: 'paddingBytesAfter',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'paddingBytes-after'
            },
            t: 'a'
          }, {
            n: 'encryption',
            an: {
              lp: 'encryption'
            },
            t: 'a'
          }, {
            n: 'compression',
            an: {
              lp: 'compression'
            },
            t: 'a'
          }]
      }, {
        ln: 'Count',
        tn: null,
        bti: '.AbstractDataComponentType',
        ps: [{
            n: 'constraint',
            ti: '.AllowedValuesPropertyType'
          }, {
            n: 'quality',
            mno: 0,
            col: true,
            ti: '.QualityPropertyType'
          }, {
            n: 'value',
            ti: 'Integer'
          }, {
            n: 'referenceFrame',
            an: {
              lp: 'referenceFrame'
            },
            t: 'a'
          }, {
            n: 'axisID',
            ti: 'Token',
            an: {
              lp: 'axisID'
            },
            t: 'a'
          }]
      }, {
        ln: 'QuantityRangePropertyType',
        ps: [{
            n: 'quantityRange',
            rq: true,
            en: 'QuantityRange',
            ti: '.QuantityRange'
          }]
      }, {
        ln: 'TextPropertyType',
        ps: [{
            n: 'text',
            rq: true,
            en: 'Text',
            ti: '.Text'
          }]
      }, {
        ln: 'TimeIntervalGridType',
        bti: '.TimeGridType',
        ps: [{
            n: 'windowDuration',
            rq: true,
            ti: 'Duration'
          }, {
            n: 'windowInterval',
            rq: true,
            ti: 'GML_3_1_1.TimeIntervalLengthType'
          }]
      }, {
        ln: 'AllowedValues',
        tn: null,
        ps: [{
            n: 'min',
            rq: true,
            ti: 'Double'
          }, {
            n: 'max',
            rq: true,
            ti: 'Double'
          }, {
            n: 'intervalOrValueList',
            rq: true,
            col: true,
            mx: false,
            dom: false,
            etis: [{
                en: 'interval',
                ti: {
                  t: 'l',
                  bti: 'Double'
                }
              }, {
                en: 'valueList',
                ti: {
                  t: 'l',
                  bti: 'Double'
                }
              }],
            t: 'ers'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }]
      }, {
        ln: 'VectorPropertyType',
        ps: [{
            n: 'vector',
            rq: true,
            en: 'Vector',
            ti: '.VectorType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'SimpleDataRecordType',
        bti: '.AbstractDataRecordType',
        ps: [{
            n: 'field',
            mno: 0,
            col: true,
            ti: '.AnyScalarPropertyType'
          }]
      }, {
        ln: 'CurvePropertyType',
        ps: [{
            n: 'curve',
            rq: true,
            en: 'Curve',
            ti: '.CurveType'
          }]
      }, {
        ln: 'DataBlockDefinitionPropertyType',
        ps: [{
            n: 'dataBlockDefinition',
            rq: true,
            en: 'DataBlockDefinition',
            ti: '.DataBlockDefinitionType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'XMLBlockType',
        bti: '.AbstractEncodingType',
        ps: [{
            n: 'xmlElement',
            ti: 'QName',
            an: {
              lp: 'xmlElement'
            },
            t: 'a'
          }]
      }, {
        ln: 'TimePositionListType',
        ps: [{
            n: 'value',
            ti: {
              t: 'l'
            },
            t: 'v'
          }, {
            n: 'frame',
            an: {
              lp: 'frame'
            },
            t: 'a'
          }, {
            n: 'calendarEraName',
            an: {
              lp: 'calendarEraName'
            },
            t: 'a'
          }, {
            n: 'indeterminatePosition',
            ti: 'GML_3_1_1.TimeIndeterminateValueType',
            an: {
              lp: 'indeterminatePosition'
            },
            t: 'a'
          }, {
            n: 'count',
            ti: 'PositiveInteger',
            an: {
              lp: 'count'
            },
            t: 'a'
          }]
      }, {
        ln: 'AbstractConditionalType.Condition',
        tn: null,
        ps: [{
            n: 'count',
            rq: true,
            en: 'Count',
            ti: '.Count'
          }, {
            n: 'quantity',
            rq: true,
            en: 'Quantity',
            ti: '.Quantity'
          }, {
            n: 'time',
            rq: true,
            en: 'Time',
            ti: '.Time'
          }, {
            n: '_boolean',
            rq: true,
            en: 'Boolean',
            ti: '.Boolean'
          }, {
            n: 'category',
            rq: true,
            en: 'Category',
            ti: '.Category'
          }, {
            n: 'text',
            rq: true,
            en: 'Text',
            ti: '.Text'
          }, {
            n: 'quantityRange',
            rq: true,
            en: 'QuantityRange',
            ti: '.QuantityRange'
          }, {
            n: 'countRange',
            rq: true,
            en: 'CountRange',
            ti: '.CountRange'
          }, {
            n: 'timeRange',
            rq: true,
            en: 'TimeRange',
            ti: '.TimeRange'
          }, {
            n: 'abstractDataRecord',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractDataRecord',
            ti: '.AbstractDataRecordType',
            t: 'er'
          }, {
            n: 'abstractDataArray',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractDataArray',
            ti: '.AbstractDataArrayType',
            t: 'er'
          }, {
            n: 'name',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'AbstractDataRecordType',
        bti: '.AbstractDataComponentType'
      }, {
        ln: 'ArrayType',
        ps: [{
            n: 'element',
            rq: true,
            col: true,
            ti: '.XMLDataPropertyType'
          }, {
            n: 'rs',
            an: {
              lp: 'RS'
            },
            t: 'a'
          }, {
            n: 'elementCount',
            ti: 'PositiveInteger',
            an: {
              lp: 'elementCount'
            },
            t: 'a'
          }]
      }, {
        ln: 'AbstractDataArrayType',
        bti: '.AbstractDataComponentType',
        ps: [{
            n: 'elementCount',
            rq: true,
            ti: '.AbstractDataArrayType.ElementCount'
          }]
      }, {
        ln: 'AllowedTimesPropertyType',
        ps: [{
            n: 'allowedTimes',
            rq: true,
            en: 'AllowedTimes',
            ti: '.AllowedTimes'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'PhenomenonSeriesType',
        bti: '.CompoundPhenomenonType',
        ps: [{
            n: 'base',
            rq: true,
            ti: '.PhenomenonPropertyType'
          }, {
            n: 'constraintList',
            rq: true,
            col: true,
            ti: '.DataArrayPropertyType'
          }, {
            n: 'otherConstraint',
            mno: 0,
            col: true
          }]
      }, {
        ln: 'CountRangePropertyType',
        ps: [{
            n: 'countRange',
            rq: true,
            en: 'CountRange',
            ti: '.CountRange'
          }]
      }, {
        ln: 'DataStreamDefinitionPropertyType',
        ps: [{
            n: 'dataStreamDefinition',
            rq: true,
            en: 'DataStreamDefinition',
            ti: '.DataStreamDefinitionType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Text',
        tn: null,
        bti: '.AbstractDataComponentType',
        ps: [{
            n: 'value'
          }]
      }, {
        ln: 'MultiplexedStreamFormatType',
        bti: '.AbstractEncodingType',
        ps: [{
            n: 'type',
            rq: true,
            an: {
              lp: 'type'
            },
            t: 'a'
          }, {
            n: 'version',
            rq: true,
            an: {
              lp: 'version'
            },
            t: 'a'
          }]
      }, {
        ln: 'CompoundPhenomenonType',
        bti: '.PhenomenonType',
        ps: [{
            n: 'dimension',
            rq: true,
            ti: 'PositiveInteger',
            an: {
              lp: 'dimension'
            },
            t: 'a'
          }]
      }, {
        ln: 'AbstractEncodingType',
        ps: [{
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }]
      }, {
        ln: 'TimePropertyType',
        ps: [{
            n: 'time',
            rq: true,
            en: 'Time',
            ti: '.Time'
          }]
      }, {
        ln: 'ObservableProperty',
        tn: null,
        bti: '.AbstractDataComponentType'
      }, {
        ln: 'Quantity',
        tn: null,
        bti: '.AbstractDataComponentType',
        ps: [{
            n: 'uom',
            ti: '.UomPropertyType'
          }, {
            n: 'constraint',
            ti: '.AllowedValuesPropertyType'
          }, {
            n: 'quality',
            mno: 0,
            col: true,
            ti: '.QualityPropertyType'
          }, {
            n: 'value',
            ti: 'Double'
          }, {
            n: 'referenceFrame',
            an: {
              lp: 'referenceFrame'
            },
            t: 'a'
          }, {
            n: 'axisID',
            ti: 'Token',
            an: {
              lp: 'axisID'
            },
            t: 'a'
          }]
      }, {
        ln: 'ItemPropertyType',
        ps: [{
            n: 'item',
            rq: true,
            en: 'Item',
            ti: 'AnyType'
          }]
      }, {
        ln: 'CompositePhenomenonType',
        bti: '.CompoundPhenomenonType',
        ps: [{
            n: 'base',
            ti: '.PhenomenonPropertyType'
          }, {
            n: 'component',
            rq: true,
            col: true,
            ti: '.PhenomenonPropertyType'
          }]
      }, {
        ln: 'TimeIntervalGridPropertyType',
        ps: [{
            n: 'timeIntervalGrid',
            rq: true,
            en: 'TimeIntervalGrid',
            ti: '.TimeIntervalGridType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'TimeGridType',
        bti: 'GML_3_1_1.AbstractTimeComplexType',
        ps: [{
            n: 'extent',
            rq: true,
            ti: '.TimeGridEnvelopePropertyType'
          }, {
            n: 'originPos',
            rq: true,
            ti: 'GML_3_1_1.TimePositionType'
          }, {
            n: 'origin',
            rq: true,
            ti: 'GML_3_1_1.TimeInstantPropertyType'
          }, {
            n: 'offsetDuration',
            rq: true,
            ti: 'Duration'
          }, {
            n: 'offsetInterval',
            rq: true,
            ti: 'GML_3_1_1.TimeIntervalLengthType'
          }, {
            n: 'duration',
            ti: 'Duration'
          }]
      }, {
        ln: 'TimeGeometricComplexPropertyType',
        ps: [{
            n: 'timeGeometricComplex',
            rq: true,
            en: 'TimeGeometricComplex',
            ti: '.TimeGeometricComplexType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'DataRecordPropertyType',
        ps: [{
            n: 'dataRecord',
            rq: true,
            en: 'DataRecord',
            ti: '.DataRecordType'
          }]
      }, {
        ln: 'TextBlock',
        tn: null,
        bti: '.AbstractEncodingType',
        ps: [{
            n: 'tokenSeparator',
            rq: true,
            an: {
              lp: 'tokenSeparator'
            },
            t: 'a'
          }, {
            n: 'blockSeparator',
            rq: true,
            an: {
              lp: 'blockSeparator'
            },
            t: 'a'
          }, {
            n: 'decimalSeparator',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'decimalSeparator'
            },
            t: 'a'
          }]
      }, {
        ln: 'AbstractDataArrayType.ElementCount',
        tn: null,
        ps: [{
            n: 'count',
            rq: true,
            en: 'Count',
            ti: '.Count'
          }, {
            n: 'ref',
            ti: 'IDREF',
            an: {
              lp: 'ref'
            },
            t: 'a'
          }]
      }, {
        ln: 'AnyDataPropertyType',
        ps: [{
            n: 'count',
            rq: true,
            en: 'Count',
            ti: '.Count'
          }, {
            n: 'quantity',
            rq: true,
            en: 'Quantity',
            ti: '.Quantity'
          }, {
            n: 'time',
            rq: true,
            en: 'Time',
            ti: '.Time'
          }, {
            n: '_boolean',
            rq: true,
            en: 'Boolean',
            ti: '.Boolean'
          }, {
            n: 'category',
            rq: true,
            en: 'Category',
            ti: '.Category'
          }, {
            n: 'text',
            rq: true,
            en: 'Text',
            ti: '.Text'
          }, {
            n: 'quantityRange',
            rq: true,
            en: 'QuantityRange',
            ti: '.QuantityRange'
          }, {
            n: 'countRange',
            rq: true,
            en: 'CountRange',
            ti: '.CountRange'
          }, {
            n: 'timeRange',
            rq: true,
            en: 'TimeRange',
            ti: '.TimeRange'
          }, {
            n: 'abstractDataRecord',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractDataRecord',
            ti: '.AbstractDataRecordType',
            t: 'er'
          }, {
            n: 'abstractDataArray',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractDataArray',
            ti: '.AbstractDataArrayType',
            t: 'er'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        t: 'enum',
        ln: 'ByteEncoding',
        bti: 'Token',
        vs: ['base64', 'raw', 'hex']
      }, {
        t: 'enum',
        ln: 'ByteOrder',
        bti: 'Token',
        vs: ['bigEndian', 'littleEndian']
      }],
    eis: [{
        en: 'AllowedValues',
        ti: '.AllowedValues'
      }, {
        en: 'Envelope',
        ti: '.EnvelopeType',
        sh: 'AbstractDataRecord'
      }, {
        en: 'Quantity',
        ti: '.Quantity'
      }, {
        en: 'AllowedTimes',
        ti: '.AllowedTimes'
      }, {
        en: 'BinaryBlock',
        ti: '.BinaryBlock'
      }, {
        en: 'QuantityRange',
        ti: '.QuantityRange'
      }, {
        en: 'TimeInstantGrid',
        ti: '.TimeInstantGridType',
        sh: 'TimeGrid'
      }, {
        en: 'ConditionalData',
        ti: '.ConditionalDataType',
        sh: 'AbstractDataRecord'
      }, {
        en: 'Curve',
        ti: '.CurveType',
        sh: 'AbstractDataArray'
      }, {
        en: 'ConditionalValue',
        ti: '.ConditionalValueType',
        sh: 'AbstractDataRecord'
      }, {
        en: 'SimpleDataRecord',
        ti: '.SimpleDataRecordType',
        sh: 'AbstractDataRecord'
      }, {
        en: 'PhenomenonSeries',
        ti: '.PhenomenonSeriesType',
        sh: 'CompoundPhenomenon'
      }, {
        en: 'ObservableProperty',
        ti: '.ObservableProperty'
      }, {
        en: 'Category',
        ti: '.Category'
      }, {
        en: 'Phenomenon',
        ti: '.PhenomenonType',
        sh: {
          lp: 'Definition',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'GeoLocationArea',
        ti: '.GeoLocationArea',
        sh: 'AbstractDataRecord'
      }, {
        en: 'AbstractDataArray',
        ti: '.AbstractDataArrayType'
      }, {
        en: 'TextBlock',
        ti: '.TextBlock'
      }, {
        en: 'interval',
        ti: {
          t: 'l'
        },
        sc: '.AllowedTimes'
      }, {
        en: 'Record',
        ti: '.RecordType'
      }, {
        en: 'Vector',
        ti: '.VectorType',
        sh: 'AbstractDataRecord'
      }, {
        en: 'DataStreamDefinition',
        ti: '.DataStreamDefinitionType'
      }, {
        en: 'TimeGeometricComplex',
        ti: '.TimeGeometricComplexType',
        sh: {
          lp: '_TimeComplex',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'Boolean',
        ti: '.Boolean'
      }, {
        en: 'StandardFormat',
        ti: '.StandardFormat'
      }, {
        en: 'interval',
        ti: {
          t: 'l',
          bti: 'Double'
        },
        sc: '.AllowedValues'
      }, {
        en: 'Array',
        ti: '.ArrayType'
      }, {
        en: 'valueList',
        ti: {
          t: 'l',
          bti: 'Double'
        },
        sc: '.AllowedValues'
      }, {
        en: 'Item',
        ti: 'AnyType'
      }, {
        en: 'XMLBlock',
        ti: '.XMLBlockType'
      }, {
        en: 'Interval',
        ti: '.IntervalType'
      }, {
        en: 'Text',
        ti: '.Text'
      }, {
        en: 'Position',
        ti: '.PositionType',
        sh: 'AbstractDataRecord'
      }, {
        en: 'TimeRange',
        ti: '.TimeRange'
      }, {
        en: 'CountRange',
        ti: '.CountRange'
      }, {
        en: 'Count',
        ti: '.Count'
      }, {
        en: 'valueList',
        ti: {
          t: 'l'
        },
        sc: '.AllowedTimes'
      }, {
        en: 'TimeAggregate',
        ti: '.TimeAggregateType',
        sh: {
          lp: '_TimeObject',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'AbstractDataRecord',
        ti: '.AbstractDataRecordType'
      }, {
        en: 'valueList',
        ti: {
          t: 'l',
          bti: 'Token'
        },
        sc: '.AllowedTokens'
      }, {
        en: 'DataBlockDefinition',
        ti: '.DataBlockDefinitionType'
      }, {
        en: 'DataArray',
        ti: '.DataArrayType',
        sh: 'AbstractDataArray'
      }, {
        en: 'AllowedTokens',
        ti: '.AllowedTokens'
      }, {
        en: 'ConstrainedPhenomenon',
        ti: '.ConstrainedPhenomenonType',
        sh: 'Phenomenon'
      }, {
        en: 'NormalizedCurve',
        ti: '.NormalizedCurveType',
        sh: 'AbstractDataRecord'
      }, {
        en: 'TimeGrid',
        ti: '.TimeGridType',
        sh: {
          lp: '_TimeComplex',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'DataRecord',
        ti: '.DataRecordType',
        sh: 'AbstractDataRecord'
      }, {
        en: 'SquareMatrix',
        ti: '.SquareMatrixType',
        sh: 'AbstractDataArray'
      }, {
        en: 'CompositePhenomenon',
        ti: '.CompositePhenomenonType',
        sh: 'CompoundPhenomenon'
      }, {
        en: 'MultiplexedStreamFormat',
        ti: '.MultiplexedStreamFormatType'
      }, {
        en: 'TimeIntervalGrid',
        ti: '.TimeIntervalGridType',
        sh: 'TimeGrid'
      }, {
        en: 'Time',
        ti: '.Time'
      }, {
        en: 'CompoundPhenomenon',
        ti: '.CompoundPhenomenonType',
        sh: 'Phenomenon'
      }]
  };
  return {
    SWE_1_0_1: SWE_1_0_1
  };
};
if (typeof define === 'function' && define.amd) {
  define([], SWE_1_0_1_Module_Factory);
}
else {
  var SWE_1_0_1_Module = SWE_1_0_1_Module_Factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports.SWE_1_0_1 = SWE_1_0_1_Module.SWE_1_0_1;
  }
  else {
    var SWE_1_0_1 = SWE_1_0_1_Module.SWE_1_0_1;
  }
}